import { createFileRoute } from '@tanstack/react-router';
import { VStack } from 'ui_2';
import { AstronautScreen } from '@src/components/3d/AstronautScreen';
import { IntroScreenScene } from '@src/components/3d/IntroScreen';

export const Route = createFileRoute('/3d')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <VStack className='relative h-full flex-none'>
      {/* <AstronautScreen controlState='NOFLOAT'/> */}
      <IntroScreenScene />
    </VStack>
  );
}
